module.exports = "/static/assets/7f153e165ee21eaa9b45715d93801a34.png";